import {h, Fragment} from "preact"
import { useAppState, useFacets, useProductFilters, useSort } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import {closeSidebar} from "../helpers"
import { sortOptions } from "../config"
import Select from "./elements/Select"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for="toggle-mobile-sidebar"
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets();
    const {response} = useAppState();
    const docCount = response.products?.total ?? 0

    const totalSummary = `${docCount} products`;

    const { removeAll } = useProductFilters();

    const { activeSort, setSort } = useSort(sortOptions)

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return facets?.length > 0 ? (
        <>
        <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class="ns-sidebar-wrapper ns-d-none ns-h-100"
                // style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-flex-column ns-align-items-center ns-relative">
                        <h2 class="ns-font-3 ns-color-black mobile-facets__heading">Filter and sort</h2>
                        <p class="mobile-facets__count">{totalSummary}</p>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0 ns-relative">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} key={facet?.id}/>
                                    case "stats":
                                        return <RangeFacet facet={facet} key={facet?.id}/>
                                    default:
                                        return null
                                }
                            })}
                            <li class="ns-sidebar-dropdown ns-sort-wrapper">
                                <Select
                                    value={activeSort}
                                    onChange={e => handleSortChange(e)}
                                    className="ns-selection-dropdown-sort-menu"
                                    options={options}
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="mobile-facets__footer">
                    <div class="mobile-facets__clear-wrapper">
                        <a
                            href="javascript:void(0)"
                            class="mobile-facets__clear underlined-link"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Remove All
                        </a>
                    </div>
                    <button type="button" class="button button--primary" onClick={()=>closeSidebar()}>
                        Apply
                    </button>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
